<!-- 销售订单 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
         append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <orderpoolQueryDetail v-if="showStatus" ref="orderpoolQueryDetail" @drawerCancel="drawerCancel"
            :actionData="actionData"></orderpoolQueryDetail>
      </el-drawer>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
            @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :flagList="['orderState']"
               :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData"
               @searchData="searchData" @openSearch="openSearch">
               <template slot="searchInput" slot-scope="{formOneValue}">
                  <el-select filterable v-if="formOneValue.entityField == 'orderState'"
                     v-model="getRequestData[formOneValue.entityField]">
                     <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys"
                        :label="values.value" :value="values.key">
                     </el-option>
                  </el-select>
               </template>
            </v-search>

         </div>
      </div>
      <div class="page_content_center">
         <el-table v-if="pageShowData.jurTableVo" @sort-change="sortChange" class="table1" stripe :data="returnData.list" :height="tableHeight"
            :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" v-if="tableValye.isShow == 1"
               v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
               show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
               :label="tableValye.showField" :sortable="tableValye.isSort == 1?'custom':false" >
               <template slot-scope="scope">
                  <span v-if="tableValye.fieldType == 'date'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>
                  <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                     {{ scope.row.isWms == 0 ? '否' : '是' }}
                  </el-tag>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{
                        scope.row[tableValye.entityField] }}</a>
                  </span>
                  <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                     {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                     }}</el-tag>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
            @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
      <el-dialog title="绑定客户" :visible.sync="dialogVisibleCmname" width="30%">
         单位名称： <el-input clearable v-model="info.cmName" :id="'cmName'"
            @keyup.enter.native="openSearch1('3391151360249856', 0, 'cmName', 'cmName,cmId')">
            <el-button @click="openSearch1('3391151360249856', 0, 'cmName', 'cmName,cmId')" slot="append"
               icon="el-icon-search">
            </el-button>
         </el-input>
         <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleCmname = false">取 消</el-button>
            <el-button type="primary" @click="sureSubmitsm">确 定</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import orderpoolQueryDetail from "@/components/orderpoolQueryDetail.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme, orderpoolQueryDetail },
   data() {
      //这里存放数据
      return {
         dialogVisibleCmname: false,
         info: {

            cmName: '',
            cmCode: '',
         },
         tableHeight: 0,
         getRequestData: {
            unitName: "",//单位名称
            businessId: "",
            orderState: "",  //
            page: 1,
            rows: 30,
            start: '',	//开始上一个月
            end: '',	//当天最后时间
         },
         returnData: {
            pages: 0,  // 总页数
            total: 0,  // 总条数
            pageNum: 0,  // 当前页数
            list: []
         },
         sField: '',
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         seId: 0,
         cmId: 0,
         showStatus: false,
         actionData: {},
         parentSearchData: {},
         multipleSelection: []
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.cmName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.cmId = ''
            }
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      sortChange(column) {
         this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
      },
      handleSelectionChange(val) {
         this.multipleSelection = val
      },
      // 子组件触发
      drawerCancel() {
         this.showStatus = false
         this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页    
            var isPenetrate = true
            // 设置缓存 存入点击单号
            this.resetSetItem('penetrateOrderId', orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({  //向窗口发送MessageEvent消息
               cmd: 'returnFormJson',
               params: { isPenetrate } //参数
            }, '*');
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      // 检索Id, 索引(表格中), 标识
      openSearch1(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seId == '3391151360249856') {
               this.info.cmCode = val.cmCode
               this.info.cmName = val.cmName
            } else {
               this.paramValue(val)

            }
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      isShowData(name, value) {
         switch (name) {
            case 'customerList':
               var dataInfo = sessionStorage.getItem('selectCustomerData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.getRequestData.cmId = dataInfo.cmId
                  this.getRequestData.cmName = dataInfo.cmName
               }

               break;

            default:
               this.getRequestData[name] = value

         }
      },

      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path)
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
         if (responseData.status == 200) {
            this.getButtonList()
            this.pageShowData = responseData.result
            this.formDataList = this.pageShowData.jurFormVoList
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      async sureSubmitsm() {
         const responseData = await this.$http.orderpoolBindUnit(this.info)
         if (responseData.status == 200) {
            this.$message.success(responseData.message)
            this.dialogVisibleCmname = false
            this.getDataList()
         } else {
            this.$message.error(responseData.message)
         }
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 0:
               if (this.returnData.list.length <= 0) {
                  if (!dataInfo) {
                     this.$message({
                        message: '暂无数据',
                        type: 'error'
                     });
                     return false
                  }
               }
               if (this.multipleSelection.length != 1) {
                  this.$message({
                     message: '请先选中一条要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = this.multipleSelection[0]
               this.showStatus = true
               this.actionData = {
                  cate: 2, formData: this.pageShowData.jurTableVo,
                  oldData: dataInfo, orderId: dataInfo.orderId, printSouce: '',
                  printJurId: '', type: 'one'
               }
               break;
            case 1://修改
               if (this.returnData.list.length <= 0) {
                  if (!dataInfo) {
                     this.$message({
                        message: '暂无数据',
                        type: 'error'
                     });
                     return false
                  }
               }
               if (this.multipleSelection.length != 1) {
                  this.$message({
                     message: '请先选中一条要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = this.multipleSelection[0]
               this.showStatus = true
               this.actionData = {
                  cate: 1, formData: this.pageShowData.jurTableVo,
                  oldData: dataInfo, orderId: dataInfo.orderId, printSouce: '',
                  printJurId: '', type: 'one'
               }
               break;
            case 2:
               if (this.returnData.list.length <= 0) {
                  this.$message({
                     message: '暂无数据',
                     type: 'error'
                  });
                  return false
               }
               this.del()
               break;
            case 3:
               if (this.returnData.list.length <= 0) {
                  this.$message({
                     message: '暂无数据',
                     type: 'error'
                  });
                  return false
               }
               if (this.multipleSelection.length != 1) {
                  this.$message({
                     message: '请先选中一条要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = this.multipleSelection[0]
               if (dataInfo.orderState != 0 && dataInfo.orderState != -1) {
                  return this.$message({
                     message: '该状态不允许修改绑定单位',
                     type: 'error'
                  });
               }
               this.info.cmCode = ''
               this.info.cmName = ''
               this.info.poolId = dataInfo.poolId
               this.dialogVisibleCmname = true
               break;
            case 6://重置
               if (this.returnData.list.length <= 0) {
                  this.$message({
                     message: '暂无数据',
                     type: 'error'
                  });
                  return false
               }
               this.resetInit()
               break;
            case 7://华源重置
               if (this.returnData.list.length <= 0) {
                  this.$message({
                     message: '暂无数据',
                     type: 'error'
                  });
                  return false
               }
               this.hyResetInit()//华源重置
               break;
         }
      },
      // 华源重置
      hyResetInit() {
         if (this.multipleSelection.length == 0) {
            this.$message({
               message: '请先选中一条要操作的数据',
               type: 'error'
            });
            return false
         }
         this.$confirm('确定要重置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: "info"
         }).then(async () => {
            const params = {
               ids: this.multipleSelection.map(item => item.orderId),
            }
            const responseData = await this.$http.resetHyState(params)
            if (responseData.status == 200) {
               this.$message.success(responseData.message)
               this.getDataList()
            } else {
               this.$message.error(responseData.message)
            }
         })
      },
      resetInit() {
         if (this.multipleSelection.length == 0) {
            this.$message({
               message: '请先选中一条要操作的数据',
               type: 'error'
            });
            return false
         }
         this.$confirm('确定要重置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: "info"
         }).then(async () => {
            const params = {
               ids: this.multipleSelection.map(item => item.orderId),
            }
            const responseData = await this.$http.resetInit(params)
            if (responseData.status == 200) {
               this.$message.success(responseData.message)
               this.getDataList()
            } else {
               this.$message.error(responseData.message)
            }
         })
      },
      del() {
         if (this.multipleSelection.length != 1) {
            this.$message({
               message: '请先选中一条要操作的数据',
               type: 'error'
            });
            return false
         }
         var dataInfo = this.multipleSelection[0]
         this.$confirm('确定要删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: "error"
         }).then(async () => {
            const params = {
               ids: [dataInfo.orderId],
            }
            const responseData = await this.$http.orderpooldelete(params)
            if (responseData.status == 200) {
               this.$message.success(responseData.message)
               this.getDataList()
            } else {
               this.$message.error(responseData.message)
            }
         })
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         if (!dataInfo) {
            this.$message({
               message: '请先选中要操作的数据',
               type: 'error'
            });
            return false
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            var info = this.returnData.list[this.selectedDataIndex]
            this.$refs.printPlan.openDia(info.woamId)
         } else {
            return
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getXOorderPoolList(this.getRequestData)
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData))
            this.returnData.list = resData.result.list
            this.returnData.pages = resData.result.pages
            this.returnData.total = resData.result.total
            this.returnData.pageNum = resData.result.pageNum
            this.selectedDataIndex = 0

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, '')
            let arr = JSON.parse(str)
            let len = arr.length
            let newStr = ''
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value
                  break;
               }
            }
            return newStr
         } catch (ex) {
            return str
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
         console.log(this.buttonList);
      },
      initTime() {
         this.getRequestData.start = this.$common.getStartTime()
         this.getRequestData.end = this.$common.getEndTime()
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.initTime()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
</style>
